const BODY_OPEN_CLASS = 'krone-nav-open';
// Single shared Alpine store. Header (top-level buttons + panels) and the
// page-level overlay all read/write via $store.desktopNav.
export function registerDesktopNav() {
    const store = {
        openId: null,
        lastTrigger: null,
        isOpen(id) {
            return this.openId === id;
        },
        toggle(id) {
            if (this.openId === id) {
                this.close();
                return;
            }
            this.lastTrigger = document.activeElement;
            this.openId = id;
            document.body.classList.add(BODY_OPEN_CLASS);
        },
        close() {
            if (this.openId === null)
                return;
            this.openId = null;
            document.body.classList.remove(BODY_OPEN_CLASS);
            const trigger = this.lastTrigger;
            this.lastTrigger = null;
            if (trigger && typeof trigger.focus === 'function') {
                requestAnimationFrame(() => trigger.focus());
            }
        },
    };
    window.Alpine.store('desktopNav', store);
}
